"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createPipelineStageReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _PipelinesAPI = require("reference-resolvers/api/PipelinesAPI");

var _createSimpleCachedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createSimpleCachedReferenceResolver"));

var _get = _interopRequireDefault(require("transmute/get"));

var _propertyTranslator = require("property-translator/propertyTranslator");

/**
 * @deprecated Translation of values in a data fetching library is bad practice
 *
 * Due to some expectations set by other apps, we have to show translated
 * values for deal stages. However, running translations on plain english
 * strings and translating data inside of a data resolver are both bad
 * practices that we should avoid. Please do not copy this pattern to other
 * resolvers.
 */
var createPipelineStageReferenceResolver = function createPipelineStageReferenceResolver(options) {
  return (0, _createSimpleCachedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.DEAL_PIPELINE_STAGES,
    createFetchData: _PipelinesAPI.createGetAllPipelines,
    fetchData: _PipelinesAPI.getAllPipelines,
    selectReferences: function selectReferences(pipeline) {
      return (0, _get.default)('stages', pipeline).map(function (stage) {
        return stage.set('label', (0, _propertyTranslator.propertyLabelTranslator)(stage.get('label')));
      });
    }
  }, options));
};

exports.createPipelineStageReferenceResolver = createPipelineStageReferenceResolver;

var _default = createPipelineStageReferenceResolver();

exports.default = _default;